export default "__VITE_ASSET__e5ee4c22__"